// i18n area 'system' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.da-DK.meta.json.
import type { enUS } from './system'

export const daDK: typeof enUS = {
  diagnostics: {
    title: 'Diagnostik',
    subtitle: 'Hvad der er galt, værst først — samme linse som tvirt diagnose',
    reload: 'Genindlæs',
    loadError: 'Diagnosen kunne ikke læses',
    exportBundle: 'Eksportér pakke',
    exportError: 'Pakken kunne ikke oprettes',
    noProblem: 'Ingen problemer i de inspicerede områder',
    nothingInspected: 'INTET blev inspiceret — dette er ikke en sundhedsattest',
    inspected: 'Inspiceret',
    notInspected: 'IKKE inspiceret',
    localHint: "Nodens lokale områder (systemd-enheder, journal) læses kun fra CLI: tvirt diagnose --area local — vejen når API'et ikke svarer.",
    thresholds: 'mislykkede opgaver inden for {hours} t, heartbeat forsinket over {seconds} s',
    severity: {
      critical: 'Kritisk',
      warning: 'Advarsel',
      unknown: 'Ukendt'
    }
  },
  explorer: {
    title: 'Udforsk ressourcer',
    root: 'Rod',
    empty: 'Ingen ressourcer i dette scope',
    previewHint: 'Vælg et objekt for at se en forhåndsvisning',
    open: 'Åbn',
    openScoped: 'Åbn listen i dette scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM-template',
      ct: 'CT',
      ctTemplate: 'CT-template',
      app: 'App',
      overlayNetwork: 'Overlay-netværk',
      networkService: 'Netværkstjeneste',
      fabric: 'Fabric',
      subnet: 'Subnet',
      storage: 'Storage-pool',
      disk: 'Disk',
      catalogFile: 'Katalogfil',
      ociRegistry: 'OCI-registry',
      ociImage: 'OCI-image',
      cephCluster: 'Ceph-cluster',
      backupDestination: 'Backup-destination',
      user: 'Bruger',
      group: 'Gruppe',
      role: 'Rolle',
      credential: 'Credential',
      tag: 'Tag',
      proximityRule: 'Proximity-regel'
    }
  },
  tags: {
    title: 'Tags',
    empty: 'Ingen tags',
    add: 'Tilføj tag',
    remove: 'Fjern',
    name: 'Tag',
    value: 'Værdi',
    save: 'Gem',
    saveError: 'Kunne ikke gemme taggene',
    loadError: 'Kunne ikke indlæse tag-ordforrådet',
    noVocabulary: 'Ingen tags tilgængelige for denne ressourcetype',
    overwrite: 'Erstat den nuværende værdi',
    createTitle: 'Opret tag',
    editTitle: 'Rediger tag',
    nameHint: 'Bogstaver, cifre, punktummer, bindestreger og underscore — hverken ":" eller "/"; præfikset tvirt- er reserveret til platformen',
    cardinality: 'Kardinalitet',
    cardinalitySingle: 'Én enkelt værdi',
    cardinalityMultiple: 'Flere værdier',
    cardinalityHint: 'Med én enkelt værdi spørger en ny tildeling af tagget, om værdien skal erstattes',
    autoCreate: 'Auto-oprettelse af værdier',
    autoCreateOn: 'Ved tildeling',
    autoCreateOff: 'Kun erklærede',
    autoCreateHint: 'Til: tildeles en ny værdi, oprettes den. Fra: kun erklærede værdier kan tildeles',
    values: 'Værdier',
    noValues: 'Ingen erklærede værdier',
    addValue: 'Tilføj værdi',
    duplicateValue: 'Duplikeret værdi',
    kinds: 'Ressourcetyper',
    kindsAll: 'Alle',
    kindsPlaceholder: 'Alle',
    kindsHint: 'Lad stå tomt for at tillade enhver tagbar ressourcetype',
    systemChip: 'System',
    deleteCascade: 'Fjern også tildelingerne',
    deleteCascadeHint: 'Et tag, der stadig er tildelt en ressource, afvises: med denne indstilling forsvinder værdierne og alle tildelinger sammen med tagget.'
  },
  scopes: {
    title: 'Scopes',
    createTitle: 'Opret scope',
    editTitle: 'Omdøb scope',
    path: 'Sti',
    segment: 'Segment',
    segmentHint: 'Små bogstaver, cifre og bindestreger (DNS-1123)',
    parent: 'Forælder',
    rootChip: 'Rod',
    preview: 'Nyt scope',
    pickLabel: 'Scope',
    pickHint: 'Hvor objektet bor i clusterets træ — roden eller et vDC inde i det.',
    ociCache: 'OCI-cache (override)',
    appEphemeral: 'Efemere App-pools (override)',
    inherit: 'Arv',
    inheritsFrom: 'Arver fra',
    inheritsCluster: 'Arver clusterets default',
    inheritsNone: 'Arver — ingen effektiv pool',
    failoverProtection: 'Beskyttelse i degraderet klynge',
    networkWeight: 'Netværksvægt',
    networkCeil: 'Netværksloft (Mbps)',
    protectionProtected: 'Beskyttet',
    protectionExpendable: 'Kan ofres ved degradering',
    protectionDefault: 'Klyngestandard'
  },
  sysinfo: {
    summary: 'Platformens versioner i clusteret, hver nodes komponenter, administrationsmanualen og licensen.',
    platformTitle: 'TVirt-platformen',
    platformSubtitle: 'Versioner observeret på clusterets noder',
    versionOnNodes: '{version} på {n} noder',
    versionOnOneNode: '{version} på 1 node',
    mixedVersions: 'Mere end én platformsversion i clusteret — forventet kun under en igangværende opgradering (højst to).',
    tooManyVersions: 'Mere end to platformsversioner i clusteret — det er aldrig forventet, heller ikke under en opgradering: tjek noderne herunder.',
    unreportedNodes: 'Endnu ingen versionsrapport fra: {nodes}',
    noVersionsYet: 'Ingen node har endnu rapporteret sine versioner.',
    nodesUnavailable: 'Nodelisten er ikke synlig med dine tilladelser — platformens versioner kan ikke vises.',
    colNode: 'Node',
    manualTitle: 'Administrationsmanual',
    manualSubtitle: 'Lokal kopi, serveret fra dette cluster',
    manualBody: 'Den komplette TVirt-manual som PDF, serveret direkte fra platformen — også tilgængelig i air-gappede miljøer.',
    manualLink: 'Administrationsmanual (PDF)',
    apiExplorerTitle: 'API-udforsker',
    apiExplorerSubtitle: 'OpenAPI-kontrakten, til gennemsyn',
    apiExplorerBody: 'Platformens komplette OpenAPI-kontrakt — hver rute, hvert skema og hver svarkode — kan gennemses fra browseren, serveret gennem denne node.',
    apiExplorerLink: 'Udforsk API',
    kubeTitle: 'Kubernetes-kompatibilitet',
    kubeSubtitle: 'kubectl og dets værktøjer, foran den native API',
    kubeBody: 'TVirt KubeCompat projicerer Pods, Deployments, Services, namespaces, noder og hændelser i Kubernetes-dialekten — skrivebeskyttet, plus sletning af Deployments. Hvert kald går gennem den native API med dine rettigheder: brug et app-token som bearer i din kubeconfig.',
    kubeEndpoint: 'Endpoint til kubectl',
    kubeStatusActive: 'Aktiv — Kubernetes {version}',
    kubeStatusMissing: 'Ikke installeret på denne node (pakken trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Installeret, men svarer ikke — tjek enheden trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Kontrollerer…'
  },
  licensing: {
    title: 'Clusterets licens',
    subtitle: 'Abonnementslicens — højst én pr. cluster',
    absentTitle: 'Ingen licens registreret',
    absentBody: "Uden en gyldig licens nægter clusteret at starte nye virtuelle maskiner (tændte VM'er forbliver tændte). Registrer produktnøglen, du modtog med abonnementet.",
    registerButton: 'Registrer licens',
    removeButton: 'Fjern licens',
    state: {
      ok: 'Gyldig',
      limitExceeded: 'Grænse overskredet',
      expired: 'Udløbet'
    },
    productKeyLabel: 'Produktnøgle',
    basisLabel: 'Grænsens grundlag',
    basis: {
      concurrentVms: "Samtidigt tændte VM'er",
      physicalCores: 'Fysiske kerner (hele clusteret)'
    },
    limitLabel: 'Grænse',
    usageLabel: 'Aktuelt forbrug',
    usageOf: '{used} af {limit}',
    usagePartial: 'delvis sum — {n} node(r) uden observeret CPU-topologi',
    usageUnknown: 'kan ikke observeres i øjeblikket',
    expiresLabel: 'Udløb',
    neverExpires: 'aldrig',
    registeredLabel: 'Registreret',
    gateNote: "Med en licens, der mangler, er udløbet eller over grænsen, nægter clusteret at starte NYE virtuelle maskiner. Tændte VM'er forbliver tændte, og HA-genstarter påvirkes ikke.",
    devStage: 'Udviklingsfase: produktnøglen accepteres, som den er, sammen med de grænser, der erklæres her; validering med signeret nøgle kommer i en fremtidig release.',
    dialogTitle: 'Registrer licens',
    dialogExpiresHelp: 'Tomt = licensen udløber aldrig',
    dialogSubmit: 'Registrer',
    dialogError: 'Kunne ikke registrere licensen.',
    removeTitle: 'Fjern licens',
    removeBody: "Clusteret vil stå UDEN LICENS: nye virtuelle maskiner vil nægte at starte, indtil du registrerer en ny. Tændte VM'er forbliver tændte.",
    removeConfirm: 'Fjern',
    removeError: 'Kunne ikke fjerne licensen.'
  },
  rbac: {
    tabRoles: 'Roller',
    tabGrants: 'Delegeringer',
    rolesTitle: 'Roller',
    createRoleTitle: 'Opret rolle',
    editRoleTitle: 'Rediger rolle',
    nameHint: 'Små bogstaver, cifre og bindestreger; præfikset tvirt- er reserveret',
    systemChip: 'System',
    permissions: 'Tilladelser',
    permissionsPlaceholder: 'Tilføj tilladelse…',
    includedRoles: 'Inkluderede roller',
    includedRolesPlaceholder: 'Tilføj rolle…',
    grantsTitle: 'Delegeringer',
    createGrantTitle: 'Opret delegering',
    principal: 'Principal',
    principalKind: 'Principal-type',
    principalUser: 'Bruger',
    principalGroup: 'Gruppe',
    role: 'Rolle',
    grantRight: 'Delegering',
    grantRightChip: 'Kan delegere',
    grantRightLabel: 'Med ret til at delegere (modtageren kan selv delegere denne rolle videre)',
    effective: 'Effektiv',
    notEffective: 'Ikke effektiv',
    createdAt: 'Oprettet',
    scopeHint: '/path præcis, /path/* rekursiv — delegeringer forankres i en monteret rod (/* kan ikke delegeres)'
  },
  groups: {
    title: 'Grupper',
    createTitle: 'Opret gruppe',
    nameHint: 'Små bogstaver, cifre og bindestreger; unikt i scopet',
    members: 'Medlemmer',
    membersTitle: 'Medlemmer',
    membersPlaceholder: 'Tilføj bruger…',
    noMembers: 'Ingen medlemmer',
    realmMappings: 'Realm-mapninger',
    realmMappingsTitle: 'Realm-mapninger',
    realmMappingsHint: 'Hvad denne gruppe svarer til i hvert eksternt realm. Medlemskabet læses fra directoryet ved login: en directory-gruppe, som ingen mapper her, ignoreres, og indlejring opløses ikke — den skal flades ud på directory-siden.',
    realm: 'Realm',
    externalGroup: 'Ekstern gruppe',
    addRealmMapping: 'Tilføj mapning',
    removeRealmMapping: 'Fjern mapning',
    noRealmMappings: 'Ingen realm-mapninger',
    sectionGeneral: 'Generelt',
    mappingsNoRealms: 'Intet eksternt realm konfigureret — mapningsfladen låses op, så snart et realm findes.',
    mappingsNoRealmsLink: 'Åbn fanen Realms og SSO',

    // MFA-kravet pålagt af gruppen (runde #178, halvdel B): et rent OR — en
    // gruppe kan kun TILFØJE kravet, aldrig ophæve det.
    mfaRequired: 'MFA-krav',
    mfaRequiredChip: 'Pålægger MFA',
    mfaNotRequiredChip: 'Intet krav',
    mfaRequiredHint:
      'Rent OR: en gruppe kan TILFØJE kravet om anden faktor for sine medlemmer — også for eksterne identiteter, via realm-mapningerne — aldrig ophæve det. Det gælder fra næste login: åbne sessioner lukkes ikke.'
  },
  users: {
    title: 'Brugere',
    createTitle: 'Opret bruger',
    editTitle: 'Rediger bruger',
    username: 'Brugernavn',
    usernameHint: 'Små bogstaver, cifre, punktummer og bindestreger',
    displayName: 'Vist navn',
    enabled: 'Aktiveret',
    state: 'Status',
    enabledChip: 'Aktiveret',
    disabledChip: 'Deaktiveret',
    lockedChip: 'Låst',
    password: 'Adgangskode',
    passwordSetChip: 'Sat',
    mustChangeChip: 'Skal skiftes',
    initialPassword: 'Startadgangskode',
    initialPasswordHint: 'Brugeren skal skifte den ved første login',
    lastLogin: 'Seneste login',
    neverLoggedIn: 'Aldrig logget ind',
    setPasswordTitle: 'Sæt adgangskode',
    setPasswordHint: 'Administrativ erstatning — kræver din adgangskode (sudo-tilstand) og tvinger brugeren til at skifte den ved næste login.',
    operatorPassword: 'Din adgangskode',
    unlock: 'Lås kontoen op',
    revokeTitle: 'Tilbagekald sessioner',
    revokeBody: 'Alle denne brugers aktive sessioner termineres med det samme.',
    revokeIncludeTokens: 'Tilbagekald også app-tokens',
    revokeConfirm: 'Tilbagekald',
    tabAccount: 'Konto',
    tabSecurity: 'Sikkerhed',
    usernameImmutableHint: 'Brugernavnet er kontoens identitet — fastlagt ved oprettelsen',
    groups: 'Grupper',
    noGroups: 'Ingen grupper',
    mustChangePassword: 'Obligatorisk skift af adgangskode',
    failedAttempts: 'Mislykkede loginforsøg',
    lockedUntil: 'Låst indtil',
    tabUsers: 'Brugere',
    tabGroups: 'Grupper',
    tabRealms: 'Realms og SSO',
    tabMfa: 'MFA',
    mfa: {
      title: 'Anden faktor (MFA)',
      methodsTitle: 'Tilgængelige metoder',
      methodsSubtitle: 'Det, denne installation kan verificere som anden faktor',
      methodsError: 'Kunne ikke indlæse metoderegistret',
      builtinChip: 'Indbygget',
      enrollableChip: 'Enrollment i TVirt',
      delegatedChip: 'Håndteres eksternt',
      state: 'Status',
      stateActive: 'Aktiv',
      statePending: 'Afventer enrollment',
      stateNone: 'Ikke tilmeldt',
      required: 'MFA-krav',
      requiredChip: 'Obligatorisk',
      notRequiredChip: 'Ikke obligatorisk',
      enrolledAt: 'Enrollment den',
      enrolledMethods: 'Tilmeldte metoder',
      noMethods: 'Intet enrollment',
      codesRemaining: 'Resterende gendannelseskoder',
      resetTitle: 'Nulstil den anden faktor',
      resetHint: 'Enrollment og alle gendannelseskoder nulstilles: ved næste login laver brugeren sit enrollment forfra. MFA-kravet består, som det er — en administrator sætter aldrig en hemmelighed, kun nulstiller den.',
      resetConfirm: 'Nulstil',
      resetError: 'Kunne ikke nulstille den anden faktor',
      empty: 'Endnu ingen håndterede brugere — kontiene dukker op her, så snart de findes, hver med sin status for anden faktor.',

      // Halvdel B (runde #178): oprindelsen af det gældende krav, eksterne
      // enrollments med forældreløs-status, grupper der pålægger kravet.
      viaSelf: 'Personligt',
      viaSelfHint: 'Kontoens personlige bidrag (dens flag) — den eneste del, blyanten redigerer.',
      viaGroupHint: 'Krav arvet fra denne gruppe: at fjerne det personlige flag frigør ikke brugeren — man griber ind på gruppen, under fanen Grupper.',
      subject: 'Identitet',
      lastSeenAt: 'Senest bekræftet',
      enrollmentPending: 'Afventer',
      orphanChip: 'Forældreløs',
      orphanDirectoryMiss: 'Identiteten findes ikke længere i directoryet',
      orphanRealmRemoved: 'Realmet blev fjernet fra TVirt',
      orphanedAt: 'Forældreløs siden',
      directoryUuid: 'UUID i directoryet',
      externalTitle: 'Eksterne enrollments',
      externalEmpty: 'Endnu intet eksternt enrollment — det opstår ved det første login for en directory-identitet med MFA-krav.',
      orphanHelp:
        'Et forældreløst enrollment sletter aldrig sig selv: det er sikkerhedsmateriale — det bliver for audit, og dukker identiteten op i directoryet igen, finder den sin faktor igen. Den eneste udvej er den administrative nulstilling.',
      visibilityHint: 'Eksterne enrollments bor i clusterets rod: kun den, der har user.read over hele træet, ser dem.',
      orphanResetHint:
        'Den forældreløse række fjernes for altid: ingen gør krav på den længere. Dukker identiteten op i directoryet igen, laver den sit enrollment forfra.',
      enforcingTitle: 'Grupper der pålægger MFA',
      enforcingSubtitle:
        'Ankeret for kravet for eksterne identiteter er gruppen: dens realm-mapninger siger, hvilken directory-population det når. Det eksterne enrollment opstår ved det første login for den pålagte bruger.',
      enforcingEmpty: 'Ingen gruppe pålægger MFA — kravet slås til på gruppen, fra fanen Grupper.',
      enforcingError: 'Kunne ikke indlæse grupperne, der pålægger MFA'
    }
  },
  realms: {
    title: 'Autentificerings-realms',
    createTitle: 'Opret realm',
    editTitle: 'Rediger realm',
    name: 'Realm',
    nameHint: 'Domænet, brugerne skriver efter @ (example.com) — uforanderligt efter oprettelsen',
    nameImmutableHint: 'Realmets navn er stemplet i hver session og hver audit-linje, der nogensinde har nævnt det — at omdøbe det ville omskrive historien',
    kind: 'Type',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC og SAML kommer med de kommende rounds — i dag er et realm et LDAPv3-directory',
    kindCategory: 'Realm-type',
    kindSelectHint: 'Vælg typen af directory, som dette realm skal autentificere imod.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Brugernavn og adgangskode verificeres med et bind mod et LDAPv3-directory — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on fra browseren, delegeret til en OpenID Connect-identity provider — kommer med de kommende rounds.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Single sign-on til virksomheder med SAML 2.0-assertioner — kommer med de kommende rounds.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Aktiveret',
    urls: 'Directory-servere',
    urlsHint: 'Én ldap://- eller ldaps://-URL pr. linje (1–8), prøvet i rækkefølge — failover, aldrig balancering',
    startTls: 'StartTLS',
    verifyCertificate: 'Verificer certifikatet',
    cleartextWarning: 'Uden ldaps:// eller StartTLS krydser bind-adgangskoden netværket i klartekst — acceptabelt i laboratoriet, aldrig i produktion.',
    noVerifyWarning: 'En uverificeret TLS-session autentificerer ingen: slå kun verifikationen fra mod et directory, du ikke kan reparere.',
    caCertificate: 'CA-certifikat (PEM)',
    caCertificateHint: 'Valgfrit CA-bundle fastgjort til dette realms TLS/StartTLS-handshake; tomt fjerner det',
    caCertificatePinned: 'Fastgjort',
    connectTimeout: 'Timeout (sekunder)',
    connectTimeoutHint: 'Frist pr. URL for forbindelse og forespørgsel (1–60); når den udløber, prøves næste URL',
    bindDn: 'Bind-DN',
    bindDnHint: 'Servicekontoen, der udfører brugersøgningen; tom = anonymt search bind (afvises af AD)',
    anonymousBind: 'Anonymt search bind',
    bindCredential: 'Bind-adgangskode (keystore)',
    bindCredentialHint: 'En usernamePassword-post i keystoret med bind-adgangskoden — hemmeligheden bor aldrig på realmet',
    bindCredentialNone: 'Ingen (anonymt bind)',
    bindCredentialEmpty: 'Ingen usernamePassword-post i keystoret — opret en i System > Credentials til bind-adgangskoden.',
    baseDn: 'Base-DN',
    baseDnHint: 'Undertræet, som brugersøgningen starter fra (DC=example,DC=com)',
    userFilter: 'Brugerfilter',
    userFilterHint: '%u erstattes af login-navnets lokale del, med RFC 4515-escape; ikke-AD-directories vil typisk have (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'memberOf-attribut',
    memberOfAttributeHint: 'Læses én gang, ved login — umappede grupper ignoreres, indlejring opløses ikke',
    uuidAttribute: 'UUID-attribut',
    uuidAttributeHint: 'Det uforanderlige UUID i realmet (objectGUID på AD, entryUUID på OpenLDAP) — stemplet i audit ved siden af bruger@realm',
    displayNameAttribute: 'Attribut for vist navn',
    displayNameAttributeHint: 'Bruges til at hilse på brugeren; mangler den, bruges login-navnet',
    sudoHint: 'Skrivninger på realms er sudo-beskyttede: et realm er en indgangsdør til platformen',
    deleteBody: 'Realmets gruppemapninger følger med det i graven; de sessioner, det har autentificeret, lever videre til udløb — et slettet realm lukker bare ikke flere ind.',
    tabConnection: 'Forbindelse',
    tabDirectory: 'Directory',
    testTitle: 'Test forbindelsen',
    testHint: 'En konfigurationssonde, aldrig en autentificering: den forbinder, binder med servicekontoen og — med et brugernavn — kører brugerfilteret.',
    testUsername: 'Brugernavn (valgfrit)',
    testUsernameHint: 'En lokal del at køre brugerfilteret på — 1 match er det sunde svar',
    testRun: 'Kør testen',
    testError: 'Kunne ikke køre sonden',
    testReachable: 'Directoryet kan nås, service-bind accepteret',
    testUnreachable: 'Directoryet kan IKKE nås',
    matchedOne: 'Brugerfilteret fandt præcis 1 post — det sunde svar.',
    matchedNone: 'Brugerfilteret fandt ingen poster: filteret eller base-DN er forkert.',
    matchedMany: 'Brugerfilteret fandt {count} poster: det er ikke selektivt, og logins ville være tvetydige (afvist).',
    mappingsPointer: 'Hvad en ekstern gruppe svarer til, er en egenskab ved TVirt-gruppen (dens realm-mapninger): sandhedspunktet bor i fanen Grupper.',
    mappingsPointerLink: 'Åbn fanen Grupper',
    rootHomeHint: 'Identiteter fra et eksternt realm bor i clusterets rod, aldrig i et vDC: tilladelser tildeles dér, hvor der er brug for dem, med delegeringer — på gruppen eller direkte på brugeren, præcis som for de native.'
  },
  credentials: {
    title: 'Credentials',
    createTitle: 'Opret credential',
    editTitle: 'Rediger credential',
    kind: 'Type',
    kindUsernamePassword: 'Brugernavn og adgangskode',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph-identitet)',
    kindHintUsernamePassword: 'Uforanderlig. Til CIFS/SMB-storage — mount-kontoen, hvis hemmelighed workeren bruger i mount-øjeblikket.',
    kindHintIscsiChap: 'Uforanderlig. Til iSCSI CHAP-autentificering — brugernavn = CHAP-navn, secret = CHAP-hemmelighed.',
    kindHintNvmeDhchap: 'Uforanderlig. Til DH-HMAC-CHAP i NVMe over Fabrics — secret = DHHC-1:xx:…-blobben; brugernavnet er kun en etiket.',
    kindHintCephx: 'Uforanderlig. Til Ceph-klienter — brugernavn = klientnavn (client.…), secret = base64-nøglen.',
    kindImmutableHint: 'Typen er uforanderlig efter oprettelsen — at ændre den betyder en ny credential.',
    username: 'Brugernavn',
    usernameChap: 'CHAP-navn',
    usernameNvme: 'Etiket',
    usernameCephx: 'Klientnavn',
    usernameHint: 'Valgfri konto, som hemmeligheden hører til',
    usernameHintChap: 'CHAP-navnet, som initiatoren autentificerer sig med',
    usernameHintNvme: 'Bruges ikke af transporten — en fri etiket til dine noter',
    usernameHintCephx: 'cephx-klientens navn — præfikset client. tolereres',
    secret: 'Hemmelighed',
    secretHint: 'Kun skrivning: bruges af konsumenterne, vises aldrig igen.',
    secretHintNvmeDhchap: 'Kun skrivning: DH-HMAC-CHAP-host-hemmeligheden i den kanoniske form DHHC-1:xx:… — bruges af konsumenterne, vises aldrig igen.',
    secretHintCephx: 'Kun skrivning: cephx-nøglen i base64 — bruges af konsumenterne, vises aldrig igen.',
    secretEditHint: 'Lad stå tomt for ikke at ændre hemmeligheden — udfyldes det, roteres den.',
    createdAt: 'Oprettet',
    inUseError: "'{name}' refereres af konfigurationen for en storage — frakobl den dér først.",
    nameHint: 'Små bogstaver, cifre og bindestreger (DNS-1123); unik pr. scope',
    rotateTitle: 'Roter hemmelighed',
    rotateHint: 'Kun skrivning: den nye hemmelighed erstatter den gemte — konsumenterne bruger den ved næste mount.',
    tabSecrets: 'Hemmeligheder',
    tabCertificates: 'Certifikater',
    tabAuthorities: 'Certificeringsmyndigheder',
    certificatesTitle: 'Certifikater',
    authoritiesTitle: 'Certificeringsmyndigheder',
    caCreateTitle: 'Ny CA',
    certCreateTitle: 'Nyt certifikat',
    caMode: 'Oprindelse',
    caModeGenerate: 'Generer med TVirt',
    caModeImport: 'Importer (nøgle + certifikat)',
    certMode: 'Oprindelse',
    certModeIssue: 'Udsted fra en CA i keystoret',
    certModeImport: 'Importer (nøgle + certifikat)',
    issuingCa: 'Udstedende CA',
    issuingCaHint: "Certifikatet fødes i CA'ens scope, med sin parent registreret",
    noCasHint: 'Ingen CA i keystoret — generer eller importer først en i fanen CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: "CA'ens subject: bogstaver, cifre, mellemrum, punktum, underscore, bindestreg",
    commonNameCertHint: 'OpenVPN identificerer klienterne på CN — hold det unikt pr. CA',
    days: 'Gyldighed (dage)',
    daysCaHint: '1–7300 dage; 3650 (10 år) er default',
    daysCertHint: '1–3650 dage; 365 er default',
    keyType: 'Nøgletype',
    keyTypeHint: 'EC P-256 er default; RSA til legacy-konsumenter',
    usage: 'Anvendelse',
    usageClient: 'Klient (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'Det extended key usage, certifikatet udstedes til',
    san: 'Alternative navne (SAN)',
    sanHint: 'Kommaseparerede; IP-literaler bliver IP:-poster, resten DNS:',
    keyPem: 'Privat nøgle (PEM)',
    keyPemHint: 'Kun skrivning: opbevares i keystoret, vises aldrig igen',
    certPem: 'Certifikat (PEM)',
    certPemHint: 'Det offentlige certifikat, der parres med nøglen',
    certPemCaHint: 'CA-certifikatet, der parres med nøglen (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Udsteder',
    parentCa: 'Udstedende CA',
    parentCaImported: 'Importeret — udstedt uden for TVirt',
    serial: 'Serienummer',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Gyldigt fra',
    validUntil: 'Gyldigt til',
    expiry: 'Udløb',
    expired: 'Udløbet',
    expiresInDays: 'Udløber om {days} d.',
    revoked: 'Tilbagekaldt',
    revokedAtLabel: 'Tilbagekaldt den',
    revokeTitle: 'Tilbagekald certifikat',
    revokeAction: 'Tilbagekald',
    revokeWarning: "Tilbagekaldelsen er endelig: serienummeret ryger i den udstedende CA's CRL, og enhver konsument, der afviser tilbagekaldte certifikater (først og fremmest OpenVPN), vil afvise dette. Un-revoke findes ikke.",
    exportPem: 'Eksporter PEM',
    exportChain: 'Eksporter kæde-bundle',
    exportCrl: 'Eksporter CRL',
    materialImmutableHint: 'X.509-materialet er uforanderligt — udsted igen eller reimporter',
    caInUseError: "'{name}' har stadig levende udstedte certifikater (eller en storage refererer til den) — tilbagekald eller slet dem først."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: "Placement, tilgængelighed og affinitet — hvor clusterets VM'er kører, og om de skal være tændt",
    loadError: 'Proximity-panelet kræver cluster-storen — flådens tilstand kan ikke nås lige nu',
    config: {
      title: 'Konfiguration',
      subtitle: 'Placement-politik på cluster-niveau',
      save: 'Gem',
      saveError: 'Konfigurationen blev afvist',
      strategy: 'Udvælgelsesstrategi',
      strategy_leastUsedResources: 'Færrest brugte ressourcer',
      strategy_leastVms: "Færrest VM'er",
      strategy_random: 'Tilfældig',
      strategyLeastUsedResourcesHint: "Blandt de gyldige kandidater vælges noden med mest resterende brugbar RAM (observeret total − host-reserve − tændte VM'er); vCPU-forpligtelsen afgør ved lighed. Deterministisk ved ens data.",
      strategyLeastVmsHint: "Blandt de gyldige kandidater vælges noden med færrest tændte VM'er; lighed afgøres efter navn. Deterministisk ved ens data.",
      strategyRandomHint: 'Ensartet tilfældig blandt de gyldige kandidater.',
      liveness: 'Livstegnstærskel for noder (sekunder)',
      livenessHint: "Et medlem, der er tavst ud over tærsklen, kan ikke nås: udelukket fra placement og — hvis ikke i vedligeholdelse — anset for dødt af HA-decideren, som fencer det og genstarter dets HA-VM'er andetsteds.",
      decider: 'HA-decider',
      deciderNone: 'endnu ikke valgt'
    },
    nodesTitle: 'Noder',
    nodesSubtitle: 'Livstegn og empirisk kapacitet — brugbar RAM = total − base − forpligtet',
    nodeCol: 'Node',
    stateCol: 'Status',
    ramCol: 'RAM (total − base − forpligtet)',
    usableCol: 'Brugbar',
    vmsCol: 'Belastning',
    neverSeen: 'aldrig set',
    freshChip: 'kan nås',
    staleChip: 'kan ikke nås',
    attestedChip: 'attesteret slukket',
    ramFormula: 'total − base − forpligtet',
    haTitle: 'Høj tilgængelighed',
    haSubtitle: "VM'er med HA-flag er \"altid tændt\": TVirt genstarter dem efter hvert stop, der ikke er bedt om — samme node med backoff, en anden node, når deres node dør (kun delt storage).",
    haNone: "Ingen VM har endnu HA-flaget — slå det til her eller i VM'ens detaljer.",
    haVmCol: 'Virtuel maskine',
    haStateCol: 'Status',
    haRestartsCol: 'HA-genstarter',
    haLastEventCol: 'Seneste hændelse',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA-ændringen blev afvist',
    rules: {
      title: 'Affinitetsregler',
      createTitle: 'Ny proximity-regel',
      editTitle: 'Rediger regel',
      nameHint: 'Små bogstaver, cifre og bindestreger (DNS-etiket)',
      vms: 'Virtuelle maskiner',
      vmsHint: "Mindst to VM'er — reglen binder, hvor de kører i forhold til hinanden",
      type: 'Type',
      affinity: 'Affinitet (sammen)',
      antiAffinity: 'Anti-affinitet (adskilt)',
      typeAffinityHint: "VM'erne skal køre på SAMME node.",
      typeAntiAffinityHint: "VM'erne skal køre på FORSKELLIGE noder — det klassiske HA-par.",
      mode: 'Tilstand',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Overtrædelser afviser operationen (start, migrering, failover) med en talende fejl.',
      modeSoftHint: 'En præference, aldrig blokerende: et placement i strid gennemføres med en synlig advarsel.',
      satisfied: 'Placement',
      satisfiedYes: 'overholdt',
      satisfiedNo: 'overtrådt',
      violations: 'Overtrædelser',
      noViolations: 'Ingen'
    },
    events: {
      title: 'HA-hændelser',
      subtitle: 'Tilgængelighedens journal — genstarter, fencing, failover og de ærlige spring-over',
      none: 'Endnu intet.',
      when: 'Hvornår',
      kind: 'Hændelse',
      target: 'Objekt',
      detail: 'Detalje',
      kindRestarted: 'HA-genstart',
      kindGaveUp: 'gav op (crash loop)',
      kindNodeAttested: 'node fencet',
      kindFailedOver: 'failover',
      kindNoCandidate: 'ingen kandidat',
      kindStorageLocalSkip: 'sprunget over (lokal storage)',
      kindZombieFenced: 'zombie termineret'
    }
  }
}
